// hooks/useAtualizarDados.ts
import { useState } from "react";
// --------------------- Import Services ---------------------
import { duplicarPostagemService } from "../../../services/duplicarPostagemService";
import { cadastrarFonteService } from "../../../services/cadastrarFonteService";
import { buscarGrupoByNameService } from "../../../services/buscarGrupoByNameService";
import { cadastrarGrupoService } from "../../../services/cadastrarGrupoService";
import { buscarFonteByNameService } from "../../../services/buscarFonteByNameService";
import { cadastrarPostagemService } from "../../../services/cadastrarPostagemService";

export const useCopiarPostagem = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<boolean | null>(null);
  const [success, setSuccess] = useState<boolean | null>(null);
  const [warning, setWarning] = useState<string | null>(null);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);
  const resetWarning = () => setWarning(null);

  const obterOuCadastrarFonte = async (nomeFonte: string) => {
    const fonte = await buscarFonteByNameService(nomeFonte);
    return fonte
      ? fonte.id
      : (await cadastrarFonteService({ nome: nomeFonte, active: 1 })).id;
  };

  const obterOuCadastrarGrupo = async (nomeGrupo: string) => {
    const grupo = await buscarGrupoByNameService(nomeGrupo);
    return grupo
      ? grupo.id
      : (await cadastrarGrupoService({ nome: nomeGrupo, active: 1 })).id;
  };

  const duplicar = async (data: any) => {
    setIsLoading(true);
    setError(null);

    try {
      const idFonte = await obterOuCadastrarFonte(data.idFonte);

      const idGrupo = await obterOuCadastrarGrupo(data.idGrupo);

      const postagemData = {
        idLeads: data.idLeads,
        idFonte,
        idGrupo,
        idEmpreendimento: data.idEmpreendimento,
        active: 1,
        dataDivulgacao: data.dataDivulgacao,
        tipoInteresse: data.tipoInteresse,
        troca: data.troca,
        aluguel: data.aluguel,
        compra: data.compra,
        venda: data.venda,
        dataIni: data.dataIni,
        dataFim: data.dataFim,
        observacoes: data.observacoes || "",
      };

      const hoje = new Date(); // cria a data de hoje
      hoje.setHours(0, 0, 0, 0); // zera hora/min/seg para comparar só a data

      const dataIni = new Date(postagemData.dataIni);
      const dataFim = new Date(postagemData.dataFim);

      if (dataIni < hoje) {
        setWarning("A data início não pode ser menor que hoje");
        return;
      }

      if (dataIni > dataFim) {
        setWarning("A data início não pode ser maior que a data fim");
        return;
      }

      ///const copiar = await duplicarPostagemService(postagemData);
      const copiar = await cadastrarPostagemService(postagemData);
      if (copiar) {
        setSuccess(true);
        setError(false);
      } else {
        setError(true);
        setSuccess(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    duplicar,
    isLoading,
    error,
    success,
    resetError,
    resetSuccess,
    warning,
    resetWarning,
  };
};
